import type {ControlOption} from 'shells/card/segmented-control';

export type DigestType = typeof DIGEST_TYPE_MORNING_DIGEST | typeof DIGEST_TYPE_TEAM_REPORT;
export type Frequency = typeof FREQUENCY_DAILY | typeof FREQUENCY_WEEKLY | typeof FREQUENCY_MONTHLY;

export const DIGEST_TYPE_MORNING_DIGEST = 'morning-digest';
export const DIGEST_TYPE_TEAM_REPORT = 'team-report';

export const FREQUENCY_DAILY = 'daily';
export const FREQUENCY_WEEKLY = 'weekly';
export const FREQUENCY_MONTHLY = 'monthly';

export const DIGEST_TYPE_OPTIONS: ControlOption<DigestType>[] = [
    {
        value: DIGEST_TYPE_MORNING_DIGEST,
        title: 'User digest',
    },
    {
        value: DIGEST_TYPE_TEAM_REPORT,
        title: 'Admin digest',
    },
];

export const FREQUENCY_OPTIONS: ControlOption<Frequency>[] = [
    {
        value: FREQUENCY_DAILY,
        title: 'Daily',
    },
    {
        value: FREQUENCY_WEEKLY,
        title: 'Weekly',
    },
    {
        value: FREQUENCY_MONTHLY,
        title: 'Monthly',
    },
];
